<ion-header [translucent]="true">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>Dokumentumaim</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-card>
          <ion-card-header style="padding:0">
            <ion-toolbar color="primary">
              <ion-title>Letölthető dokumentumok</ion-title>
              <ion-buttons slot="end">
                <ion-button (click)="loadDokumentumok()">
                  <ion-icon slot="icon-only" name="refresh"></ion-icon>
                </ion-button>
              </ion-buttons>
            </ion-toolbar>
          </ion-card-header>
          <ion-card-content style="margin:15px;">
            <div *ngIf="voltTanulo" class="volt-tanulo-jelzes">
              <ion-icon name="archive-outline" aria-hidden="true"></ion-icon>
              <div>
                <b>Megszűnt tanulói jogviszony</b>
                <span *ngIf="jogviszonyVege"> ({{ jogviszonyVege | date: 'yyyy. MM. dd.' }})</span>.
                A fiókoddal a digitális bizonyítványaidat és a többi kiállított dokumentumodat éred el,
                <ng-container *ngIf="megorzesVege">legalább {{ megorzesVege | date: 'yyyy. MM. dd' }}-ig</ng-container>
                <ng-container *ngIf="!megorzesVege">a jogviszony megszűnésétől 80 évig</ng-container>
                (Nkt. 57. § (9a)–(9b)). Módosítást ebben a módban nem végezhetsz.
              </div>
            </div>
            <p style="text-align: justify;" *ngIf="!tanulo">
              Itt találja a gyermeke(i)hez generált, hivatalos dokumentumokat
              (pl. bizonyítvány), valamint a beküldött kérvényeket és a hozzájuk
              tartozó határozatokat. A dokumentumok elektronikusan hitelesítettek.
            </p>
            <p style="text-align: justify;" *ngIf="tanulo">
              Itt találod a neked kiállított hivatalos dokumentumokat (pl. digitális bizonyítvány),
              valamint a beküldött kérvényeidet és a hozzájuk tartozó határozatokat. A dokumentumok
              elektronikusan hitelesítettek. Mindig a legutóbb kiállított, érvényes változat látszik.
            </p>

            <ngx-datatable
              class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz"
              [rows]="dokumentumok" [sortType]="SortType.single" [columnMode]="ColumnMode.force"
              [rowHeight]="'auto'" [limit]="15"
              [sorts]="[{ prop: 'letrehozva', dir: 'desc' }]"
              [messages]="{emptyMessage: 'Nincs megjeleníthető dokumentum.'}">

              <ngx-datatable-column name="Dokumentum" prop="nev">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  <b class="mobil">Dokumentum</b>
                  <span style="text-wrap: auto;">{{ value }}</span>
                  <small *ngIf="tanulo && row.intezmeny_nev" class="dok-intezmeny">{{ row.intezmeny_nev }}</small>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Típus" prop="tipus">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  <b class="mobil">Típus</b>
                  {{ tipusNev(value) }}
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Dátum" prop="letrehozva">
                <ng-template let-value="value" ngx-datatable-cell-template>
                  <b class="mobil">Dátum</b>
                  <span *ngIf="value">{{ value | date: 'yyyy. MM. dd.' }}</span>
                </ng-template>
              </ngx-datatable-column>

              <ngx-datatable-column name="Művelet">
                <ng-template let-row="row" ngx-datatable-cell-template>
                  <b class="mobil">Művelet</b>
                  <ion-button color="tertiary" size="small" style="margin-top:0"
                    [href]="'/api/file/' + row.path" target="_blank" [disabled]="!row.path">
                    <ion-icon slot="start" name="download"></ion-icon> Letöltés
                  </ion-button>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
